import { vacancyPageType } from '@lib/proptypes';
import VacancyDetail from '@organisms/VacancyDetail/VacancyDetail';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export function VacancyPageLayout({ page }) {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTHA_SITE_KEY}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: 'head',
        nonce: undefined,
      }}
    >
      <VacancyDetail page={page} />
    </GoogleReCaptchaProvider>
  );
}

VacancyPageLayout.propTypes = {
  page: vacancyPageType,
};
